import { system } from '@workday/canvas-tokens-web'

// `baseStyle` receives `props.theme`, so the `subtextSmall` atoms are read from the active
// theme. Flag-ON, subtextSmall already carries the muted hint color (`fg.muted.default`) —
// the text style is self-complete, no color override needed. Flag-OFF only, legacy helper
// text was `--vndly-color-input-text-hint` (slate-600), a hair darker than subtextSmall's
// legacy container-subdued, so we pin `fg.muted.default` (Layer-1 polyfilled to slate-600)
// to keep the legacy render byte-identical. That branch disappears at FF removal.
export const Form = {
  baseStyle: ({ theme }) => ({
    helperText: {
      ...theme.textStyles.subtextSmall,
      ...(theme.isSanaRebrand ? {} : { color: `var(${system.color.fg.muted.default})` }),
      mt: 0,
      mb: 2
    }
  })
}
